module.exports = __webpack_public_path__ + "1a15101b09d9b9925d7b9a22dfb64f60.jpg";